// Base URL configuration
// When running in Electron, use the production URL
// When running in a browser, use relative paths
const isElectron = typeof window !== 'undefined' && (window as any).electronAPI?.isElectron;

export const EXTERNAL_URL_BASE = isElectron ? 'https://easypcr-ui.pages.dev' : '.';
